/**
 * NewsCommon.ts
 * [Readme] --------------------------------------------------------------------------------------
 *
 * 서버 API로부터 새소식 데이터를 전달받도록 제어하는 기본 로직이 정의.
 *
 * -----------------------------------------------------------------------------------------------
 */

import { getNewsData, getNewsDetailData, INewsListProps } from 'common-modules/general/API/news';
import { ResponseHomeNewsDetail, ResponseHomeNews } from 'common-modules/general/API/news/types';
import MobxAsyncModel from 'common-modules/general/Model/MobxAsyncModel';
import { makeAutoObservable } from 'mobx';

export default class NewsCommonModel {
  public mainData: MobxAsyncModel<ResponseHomeNews>;
  public detailData: MobxAsyncModel<ResponseHomeNewsDetail>;

  constructor() {
    this.mainData = new MobxAsyncModel(true);
    this.detailData = new MobxAsyncModel(true);

    makeAutoObservable(this);
  }

  getData = (params: INewsListProps) => {
    getNewsData(params)
      .then(({ data }) => {
        this.mainData.loadSuccess(data);
      })
      .catch(() => {
        this.mainData.loadFailure();
      });
  };

  getNewsDetailData = (params: string, noUperWrtSral: number) => {
    getNewsDetailData(params, noUperWrtSral)
      .then(({ data }) => {
        this.detailData.loadSuccess(data);
      })
      .catch(() => {
        this.detailData.loadFailure();
      });
  };
}
